import { generateFingerprint } from 'services/fingerprint'
import { buildTracking } from 'services/tracking'

export const trackFingerprint = () => async (dispatch) => {
  const fingerprint = await generateFingerprint()
  dispatch({ type: 'TRACK_FINGERPRINT', payload: fingerprint })
}

export const initializeTracking = () => (dispatch) => {
  const tracking = buildTracking()
  dispatch({ type: 'INITIALIZE_FROM_URL', payload: tracking })
}
